import React from 'react';
import * as R from 'ramda';
import { format } from 'date-fns';
import * as PropTypes from 'prop-types';

import {
  RequestDate,
  RequestHeaderWrapper,
  RequestSubjectWrap,
  HeaderRightSide,
  RequestInfo,
  RequestStatus,
  RequestStatusTitle,
  RequestStatusDescription,
  RequestSource,
  ContactsWrapper,
  ContactName,
  RequestDateAndAssigneesWrapper,
  RequestUserAssigneesWrapper,
  RequestUserAssignees,
  HiddenAssigneesCounter,
  RequestSourceWrapper,
  SvgWrapper,
} from './styled-components';
import { Counters } from './counters';
import { Link } from '../../ui-helpers';
import { theme } from '../../../styles';
import { SvgIcon } from '../../svg-icon';
import { RequestDropdown } from './request-dropdown';
import { RequestAssignees } from './request-assignees';
import ContactDetails from '../request-info/contact-details';
import { DropdownWithDots, Popover, Tooltip } from '../../popovers';


const RequestHeader = ({
  _id,
  type,
  users,
  tasks,
  subject,
  contacts,
  requestDate,
  source,
  status,
  labels,
  budget,
  assignees,
  onTaskCreate,
  meetingNotes,
  comments,
  handleRequestUpdate,
  handleRequestDelete,
  onMeetingNoteCreate,
  onCommentCreate,
  onBudgetCreate,
  isLinkToDetailRequest,
}) => {
  const hiddenAssignees = assignees.slice(3);

  return (
    <RequestHeaderWrapper type={type}>
      <Link
        href={`/request?id=${_id}`}
        target="_blank"
      >
        <RequestInfo
          type={type}
          isPointer={isLinkToDetailRequest}
        >
          {type === 'contacts' ? (
            <Tooltip
              title={`Subject: ${subject}`}
              placement="bottomLeft"
            >
              <RequestSubjectWrap>{subject}</RequestSubjectWrap>
            </Tooltip>
          ) : (
            <Popover
              content={<ContactDetails contacts={contacts} />}
              overlayClassName="ant-popover-contacts-details"
              trigger="click"
            >
              <ContactsWrapper>
                <ContactName>
                  {R.pathOr('', ['0', 'fullName'], contacts)}
                </ContactName>
                {contacts.length > 1 ? <em> +{contacts.length - 1}</em> : ''}
              </ContactsWrapper>
            </Popover>
          )}

          <RequestSourceWrapper>
            <RequestSource color={source.color}>
              <div>
                {source.title}
              </div>
            </RequestSource>
          </RequestSourceWrapper>

          {type === 'requests' && (
            <Tooltip
              title={`Subject: ${subject}`}
              placement="bottomLeft"
            >
              <RequestSubjectWrap>{subject}</RequestSubjectWrap>
            </Tooltip>
          )}

          <RequestStatus
            isPointer={isLinkToDetailRequest}
            color={status.color}
          >
            <RequestStatusTitle needInfo={status.description}>
              <span>{status.title}</span>
              {status.description ? (
                <Popover
                  placement="top"
                  arrowPointAtCenter
                  trigger="hover"
                  onClick={e => e.stopPropagation()}
                  content={
                    <RequestStatusDescription
                      onClick={e => e.stopPropagation()}
                    >
                      {status.description}
                    </RequestStatusDescription>
                  }
                >
                  <SvgWrapper>
                    <SvgIcon
                      type="info"
                      color={theme.colors.secondaryDark}
                      fillOpacity={1}
                    />
                  </SvgWrapper>
                </Popover>
              ) : (
                ''
              )}
            </RequestStatusTitle>
          </RequestStatus>

          <Counters
            {...{
              _id,
              tasks,
              labels,
              comments,
              meetingNotes,
              onBudgetCreate,
            }}
          />

          <RequestDateAndAssigneesWrapper>
            <RequestUserAssigneesWrapper>
              <RequestUserAssignees>
                {users[assignees.slice(0, 1)] &&
                users[assignees.slice(0, 1)].fullName}
                {!R.isEmpty(hiddenAssignees) && (
                  <HiddenAssigneesCounter>{`+${
                    hiddenAssignees.length
                  }`}
                  </HiddenAssigneesCounter>
                )}
              </RequestUserAssignees>

              <RequestDate>
                {format(requestDate, 'HH:mm d MMM yyyy')}
              </RequestDate>
            </RequestUserAssigneesWrapper>

            <RequestAssignees
              users={users}
              requestId={_id}
              assignees={assignees}
              requestTasks={tasks}
            />
          </RequestDateAndAssigneesWrapper>
        </RequestInfo>
      </Link>

      <HeaderRightSide>
        <DropdownWithDots
          overlay={RequestDropdown({
            _id,
            budget,
            subject,
            contacts,
            handleRequestUpdate,
            handleRequestDelete,
            onMeetingNoteCreate,
            onCommentCreate,
            onBudgetCreate,
            onTaskCreate,
          })}
        />
      </HeaderRightSide>
    </RequestHeaderWrapper>
  );
};

RequestHeader.propTypes = {
  _id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  requestDate: PropTypes.string.isRequired,
  source: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
  contacts: PropTypes.array.isRequired,
  users: PropTypes.object.isRequired,
  labels: PropTypes.array,
  budget: PropTypes.array,
  assignees: PropTypes.array,
  subject: PropTypes.string,
  meetingNotes: PropTypes.array,
  comments: PropTypes.array,
  tasks: PropTypes.array,
  handleRequestUpdate: PropTypes.func.isRequired,
  handleRequestDelete: PropTypes.func.isRequired,
  onMeetingNoteCreate: PropTypes.func.isRequired,
  onCommentCreate: PropTypes.func.isRequired,
  onTaskCreate: PropTypes.func.isRequired,
  onBudgetCreate: PropTypes.func.isRequired,
  isLinkToDetailRequest: PropTypes.bool,
};

RequestHeader.defaultProps = {
  tasks: [],
  labels: [],
  budget: [],
  subject: '',
  assignees: [],
  meetingNotes: [],
  comments: [],
  isLinkToDetailRequest: false,
};

export default RequestHeader;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/index.js